import moment from "moment-timezone";
import "moment/locale/az";

export const TS_FMT = "YYYY-MM-DD HH:mm:ss";
export const SOURCE_TZ = "Asia/Baku";
export const TARGET_TZ = "Asia/Baku";

export const toAzMoment = (tsStr) =>
  moment.tz(tsStr, TS_FMT, SOURCE_TZ).tz(TARGET_TZ);

export const todayAzKey = () =>
  moment.tz(TARGET_TZ).locale("az").format("D MMMM, YYYY dddd");

export const fmtDateAzKey = (m) =>
  m.clone().locale("az").format("D MMMM, YYYY dddd");

export const detectPhoneNumber = (text) => {
  const trimmedText = String(text || "").trim();
  const phoneRegex = /(\+994\d{9}|\b(050|051|077|010|099|055|070)\d{7}\b)/g;
  const matches = trimmedText.match(phoneRegex);
  return matches ? matches[0] : null;
};

export const formatPhoneNumberForWhatsApp = (phoneNumber) => {
  const phone = String(phoneNumber || "");
  if (phone.startsWith("0")) {
    return `994${phone.slice(1)}`;
  }
  return phone.replace(/\D/g, "");
};

export const groupMessagesByDate = (messages) => {
  if (!messages || messages.length === 0) return [];

  const grouped = messages.reduce((groups, message) => {
    const az = toAzMoment(message.timestamp || message.createdAt);
    const messageDate = fmtDateAzKey(az);

    if (!groups[messageDate]) {
      groups[messageDate] = [];
    }

    groups[messageDate].push({
      ...message,
      timestampObj: az.toDate(),
    });

    return groups;
  }, {});

  return Object.entries(grouped)
    .map(([date, items]) => ({
      title: date === todayAzKey() ? "Bugün" : date,
      data: items.sort((a, b) => a.timestampObj - b.timestampObj),
      id: `sec-${date}`,
    }))
    .sort((a, b) => a.data[0].timestampObj - b.data[0].timestampObj);
};

export const interleaveChatAds = (list, ads, interval = 10) => {
  if (!Array.isArray(list) || !Array.isArray(ads) || ads.length === 0) return list;

  const out = [];
  let normalCount = 0;

  for (let i = 0; i < list.length; i += 1) {
    out.push(list[i]);
    normalCount += 1;

    if (normalCount % interval === 0) {
      const pick = ads[Math.floor(Math.random() * ads.length)];

      const baseStr = moment(
        list[i]?.timestamp || list[i]?.createdAt,
        "YYYY-MM-DD HH:mm:ss",
        true
      ).isValid()
        ? moment
            .tz(list[i]?.timestamp || list[i]?.createdAt, "Asia/Baku")
            .format("YYYY-MM-DD HH:mm:ss")
        : moment().tz("Asia/Baku").format("YYYY-MM-DD HH:mm:ss");

      out.push({
        id: `ad-${pick.id}-${normalCount}`,
        isAd: true,
        bannerId: pick.id,
        imageUrl: pick.imageUrl,
        description: pick.description,
        createdAt: baseStr,
        timestamp: baseStr,
      });
    }
  }

  return out;
};